import { Link } from 'react-router-dom';
import { PRODUCTS } from '../data/catalog';
import { ProductCard } from '../components/ProductCard';
import { Card } from '../components/ui';
import { useTitle } from '../components/Layout';

const bestsellers = PRODUCTS.slice(0, 4);
const promoted = PRODUCTS.filter((p) => p.listPrice);

export function Home() {
  useTitle('Meble i akcesoria do biura');

  return (
    <>
      <section className="mb-8 overflow-hidden rounded-2xl border border-[#26304d] bg-gradient-to-br from-[#1a2547] via-[#141a2e] to-[#12283f] p-6 sm:p-10">
        <div className="max-w-xl">
          <span className="rounded-full bg-[#22d3a6]/15 px-2.5 py-1 text-[11px] font-medium text-[#7ef0d0]">
            Tydzień ergonomii — do −20%
          </span>
          <h1 className="mt-3 text-2xl font-semibold text-white sm:text-3xl">
            Biuro, w którym da się przesiedzieć osiem godzin
          </h1>
          <p className="mt-2 text-[13.5px] leading-relaxed text-slate-400">
            Fotele, biurka podnoszone i oświetlenie dobrane pod pracę przy komputerze. Wysyłka w 24 h, zwrot do 30 dni.
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            <Link
              to="/katalog"
              className="rounded-lg bg-[#4f8cff] px-4 py-2 text-sm font-medium text-white hover:bg-[#3f7ae8]"
            >
              Zobacz katalog
            </Link>
            <Link
              to="/katalog?kategoria=Meble"
              className="rounded-lg border border-[#26304d] px-4 py-2 text-sm text-slate-200 hover:border-[#4f8cff]"
            >
              Meble biurowe
            </Link>
          </div>
        </div>
      </section>

      <section className="mb-10">
        <div className="mb-3 flex items-baseline justify-between">
          <h2 className="text-lg font-semibold text-white">Bestsellery</h2>
          <Link to="/katalog" className="text-[12.5px] text-[#9ec5ff] hover:underline">
            Wszystkie produkty →
          </Link>
        </div>
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {bestsellers.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      </section>

      {promoted.length > 0 && (
        <section className="mb-10">
          <h2 className="mb-3 text-lg font-semibold text-white">W promocji</h2>
          <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
            {promoted.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        </section>
      )}

      <section className="grid gap-3 sm:grid-cols-3">
        {[
          ['🚚', 'Darmowa dostawa', 'Przy zamówieniach od 2000 zł. Kurier lub paczkomat.'],
          ['↩️', 'Zwrot 30 dni', 'Bez podawania przyczyny. Zwrot kosztów w 5 dni roboczych.'],
          ['🛠️', 'Gwarancja 5 lat', 'Na mechanizmy foteli i biurek marki Nordform.'],
        ].map(([icon, title, desc]) => (
          <Card key={title} className="p-4">
            <div className="mb-1.5 text-xl">{icon}</div>
            <h3 className="text-[13.5px] font-semibold text-white">{title}</h3>
            <p className="mt-1 text-[12.5px] leading-relaxed text-slate-400">{desc}</p>
          </Card>
        ))}
      </section>
    </>
  );
}
